// Componente para item de chatroom (versión web).
// Muestra avatar, nombre, último mensaje y timestamp.
// Permite navegación al perfil del amigo y al chatroom.
// Adaptado para web desde amarsi-app.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiTrash2 } from 'react-icons/fi';
import CachedAvatarImage from '../../components/CachedAvatarImage';

function ChatRoomItem({ data, showDeleteOption, onOpenFriendProfile }) {
  const navigate = useNavigate();

  // Función para visitar perfil del amigo.
  const visitFriendProfile = () => {
    console.log('visitFriendProfile: Abriendo modal de perfil de amigo:', data.friend_id);
    if (onOpenFriendProfile) {
      onOpenFriendProfile(data.friend_id);
    } else {
      console.warn('visitFriendProfile: onOpenFriendProfile no está disponible');
    }
  };

  // Función para ir al chat.
  const goToChat = () => {
    console.log('goToChat: Navegando al chatroom:', data.chatroom_id, 'con amigo:', data.friend_id);
    navigate('/chats/chatroom', {
      state: {
        chatroom_id: data.chatroom_id,
        friend_id: data.friend_id,
        destinatario: { full_name: data.full_name, tca: data.tca, friend_id: data.friend_id },
        avatar: data.user_image ? data.user_image : null,
        thread: data.full_name
      }
    });
  };

  // Función para formatear tiempo relativo
  const formatRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'ahora';
    if (diffMins < 60) return `hace ${diffMins} min`;
    if (diffHours < 24) return `hace ${diffHours} h`;
    if (diffDays < 7) return `hace ${diffDays} días`;
    return date.toLocaleDateString('es-ES');
  };

  return (
<div className="flex items-start p-2">
  {/* Avatar con indicador de mensajes no leídos */}
  {showDeleteOption ? (
    <div
      onClick={visitFriendProfile}
      className="w-[76px] cursor-pointer flex items-center justify-center flex-shrink-0"
    >
      <div
        className="bg-gray-800/50 rounded-full flex items-center justify-center border-4 border-dashed border-primary-500"
        style={{
          width: 77,
          height: 77,
        }}
      >
        <FiTrash2 size={24} color="white" />
      </div>
    </div>
  ) : (
    <div
      onClick={visitFriendProfile}
      className="w-[76px] cursor-pointer flex items-center justify-center flex-shrink-0"
    >
      <div className={`border-4 rounded-full ${data.sin_leer > 0 ? 'border-primary-500' : 'border-transparent'}`}>
        <CachedAvatarImage
          userId={data.friend_id}
          imageUrl={data.user_image}
          style={{
            width: 70,
            height: 70,
            borderRadius: 100,
          }}
          showPlaceholder={false}
        />
      </div>
    </div>
  )}

  {/* Información del chat */}
  <div
    onClick={goToChat}
    className="flex-1 min-w-0 pl-3 pr-4 cursor-pointer"
  >
    <div className="flex justify-between items-start w-full gap-2">
      <h3 className="text-lg text-white font-medium truncate">
        {data.full_name}
      </h3>

      <div className="flex items-end flex-shrink-0">
        <span className="text-sm text-white opacity-80 whitespace-nowrap">
          {formatRelativeTime(data.created_at_last_message)}
        </span>
      </div>
    </div>

    <div className="flex justify-between items-center w-full mt-2 gap-2">
      <div className="flex-1 min-w-0">
        <MessageInfoLabel msg={data} />
      </div>

      {data.sin_leer > 0 && (
        <div
          className="w-[30px] h-[30px] bg-primary-500 rounded-full flex items-center justify-center flex-shrink-0"
        >
          <span className="text-white text-base">
            {data.sin_leer}
          </span>
        </div>
      )}
    </div>
  </div>
</div>
  );
}

// Componente para label de info del mensaje.
function MessageInfoLabel({ msg }) {
  if (msg.msg_type_last_message === 0) {
    return (
      <p className="text-base text-gray-400 italic truncate">
        {msg.last_message_enviado_por_mi ? 'Mensaje eliminado' : 'Se eliminó el mensaje'}
      </p>
    );
  }
  if (msg.msg_type_last_message === 2) {
    return (
      <p className="text-base text-gray-400 italic truncate">
        {msg.last_message_enviado_por_mi ? 'Ubicación enviada' : 'Ubicación recibida'}
      </p>
    );
  }
  if (msg.msg_type_last_message === 3) {
    return (
      <p className="text-base text-gray-400 italic truncate">
        {msg.last_message_enviado_por_mi ? 'Imagen enviada' : 'Imagen recibida'}
      </p>
    );
  }
  return (
    <p className="text-base text-gray-400 line-clamp-2">
      {msg.body}
    </p>
  );
}

export default ChatRoomItem;
